import { List } from 'immutable'
import { HttpResult } from 'widgets-for-react'
import { parse_menu } from '../../drupal/api.mod'
import { ParsedMenuItem } from '../../drupal/types_and_parser/extra_types.mod'
import { getLangFromUrl } from '../utils/history.mod'

// SREF-294: fetch with the URL region code (like the header menus), not the Drupal language, so UK/NA/NA-FR get their own footer instead of the global one.
export const getFooter = async (): Promise<HttpResult<List<ParsedMenuItem>>> => {
  const lang = getLangFromUrl()
  const menuList =
    window.__PRELOADED_DATA__ && window.__PRELOADED_DATA__.menus && window.__PRELOADED_DATA__.menus.footer
      ? window.__PRELOADED_DATA__.menus.footer
      : await (
          await fetch(`/api/drupal${lang == 'global' ? '' : `/${lang}`}/api/menu_items/footer`, {
            credentials: 'include'
          })
        ).json()

  return { kind: 'result', status: 200, value: parse_menu(menuList) }
}

export const getPrivacyMenu = async (): Promise<HttpResult<List<ParsedMenuItem>>> => {
  const lang = getLangFromUrl()
  const menuList =
    window.__PRELOADED_DATA__ && window.__PRELOADED_DATA__.menus && window.__PRELOADED_DATA__.menus.privacy
      ? window.__PRELOADED_DATA__.menus.privacy
      : await (
          await fetch(`/api/drupal${lang == 'global' ? '' : `/${lang}`}/api/menu_items/privacy`, {
            credentials: 'include'
          })
        ).json()

  return { kind: 'result', status: 200, value: parse_menu(menuList) }
}
